export const PERMISSIONS = {
    // Tableau de bord
    DASHBOARD_VIEW: 'dashboard:view',

    // Clients
    CLIENTS_READ: 'clients:read',
    CLIENTS_CREATE: 'clients:create',
    CLIENTS_UPDATE: 'clients:update',
    CLIENTS_DELETE: 'clients:delete',

    // Contrats
    CONTRATS_READ: 'contrats:read',
    CONTRATS_CREATE: 'contrats:create',
    CONTRATS_UPDATE: 'contrats:update',
    CONTRATS_DELETE: 'contrats:delete',
    CONTRATS_RENOUVELER: 'contrats:renouveler',
    CONTRATS_ECHELONNER: 'contrats:echelonner',

    // Règlements
    REGLEMENTS_READ: 'reglements:read',
    REGLEMENTS_CREATE: 'reglements:create',
    REGLEMENTS_UPDATE: 'reglements:update',
    REGLEMENTS_DELETE: 'reglements:delete',

    // Impayés
    IMPAYES_READ: 'impayes:read',
    IMPAYES_RELANCE: 'impayes:relance',

    // Sinistres
    SINISTRES_READ: 'sinistres:read',
    SINISTRES_CREATE: 'sinistres:create',
    SINISTRES_UPDATE: 'sinistres:update',
    SINISTRES_DELETE: 'sinistres:delete',
    SINISTRES_STATUT: 'sinistres:statut',

    // Bilans & États
    BILANS_READ: 'bilans:read',
    BILANS_EXPORT: 'bilans:export',
    BILANS_VERSER: 'bilans:verser',

    // Compagnies
    COMPAGNIES_READ: 'compagnies:read',
    COMPAGNIES_CREATE: 'compagnies:create',
    COMPAGNIES_UPDATE: 'compagnies:update',
    COMPAGNIES_DELETE: 'compagnies:delete',

    // Types d'assurance
    TYPES_ASSURANCE_READ: 'typesAssurance:read',
    TYPES_ASSURANCE_CREATE: 'typesAssurance:create',
    TYPES_ASSURANCE_UPDATE: 'typesAssurance:update',
    TYPES_ASSURANCE_DELETE: 'typesAssurance:delete',

    // Agences
    AGENCES_READ: 'agences:read',
    AGENCES_CREATE: 'agences:create',
    AGENCES_UPDATE: 'agences:update',
    AGENCES_DELETE: 'agences:delete',

    // Paramétrages
    PARAMETRAGES_READ: 'parametrages:read',
    PARAMETRAGES_UPDATE: 'parametrages:update',
    PARAMETRAGES_CREATE: 'parametrages:create',

    // Gestion des accès
    USERS_READ: 'users:read',
    USERS_CREATE: 'users:create',
    USERS_UPDATE: 'users:update',
    USERS_DELETE: 'users:delete',

    // Rôles
    ROLES_READ: 'roles:read',
    ROLES_CREATE: 'roles:create',
    ROLES_UPDATE: 'roles:update',
    ROLES_DELETE: 'roles:delete',

    // Audit
    AUDIT_READ: 'audit:read',

    // SMS
    SMS_SEND: 'sms:send',
};

// Ordre d'affichage des modules (aligné sur la barre de navigation)
export const PERMISSION_MODULES = [
    'Tableau de bord',
    'Gestion',
    'Rapports',
    'Configuration',
    'Administration',
];

export const PERMISSION_GROUPS = [
    {
        title: 'Tableau de bord',
        module: 'Tableau de bord',
        items: [
            { label: 'Voir le dashboard', value: PERMISSIONS.DASHBOARD_VIEW },
        ],
    },
    {
        title: 'Clients',
        module: 'Gestion',
        items: [
            { label: 'Voir les clients', value: PERMISSIONS.CLIENTS_READ },
            { label: 'Créer un client', value: PERMISSIONS.CLIENTS_CREATE },
            { label: 'Modifier un client', value: PERMISSIONS.CLIENTS_UPDATE },
            { label: 'Supprimer un client', value: PERMISSIONS.CLIENTS_DELETE },
        ],
    },
    {
        title: 'Contrats',
        module: 'Gestion',
        items: [
            { label: 'Voir les contrats', value: PERMISSIONS.CONTRATS_READ },
            { label: 'Créer un contrat', value: PERMISSIONS.CONTRATS_CREATE },
            { label: 'Modifier un contrat', value: PERMISSIONS.CONTRATS_UPDATE },
            { label: 'Supprimer un contrat', value: PERMISSIONS.CONTRATS_DELETE },
            { label: 'Renouveler un contrat', value: PERMISSIONS.CONTRATS_RENOUVELER },
            { label: 'Échelonner un contrat', value: PERMISSIONS.CONTRATS_ECHELONNER },
        ],
    },
    {
        title: 'Règlements',
        module: 'Gestion',
        items: [
            { label: 'Voir les règlements', value: PERMISSIONS.REGLEMENTS_READ },
            { label: 'Créer un règlement', value: PERMISSIONS.REGLEMENTS_CREATE },
            { label: 'Modifier un règlement', value: PERMISSIONS.REGLEMENTS_UPDATE },
            { label: 'Supprimer un règlement', value: PERMISSIONS.REGLEMENTS_DELETE },
        ],
    },
    {
        title: 'Impayés',
        module: 'Gestion',
        items: [
            { label: 'Voir les impayés', value: PERMISSIONS.IMPAYES_READ },
            { label: 'Relancer par SMS', value: PERMISSIONS.IMPAYES_RELANCE },
        ],
    },
    {
        title: 'Sinistres',
        module: 'Gestion',
        items: [
            { label: 'Voir les sinistres', value: PERMISSIONS.SINISTRES_READ },
            { label: 'Déclarer un sinistre', value: PERMISSIONS.SINISTRES_CREATE },
            { label: 'Modifier un sinistre', value: PERMISSIONS.SINISTRES_UPDATE },
            { label: 'Supprimer un sinistre', value: PERMISSIONS.SINISTRES_DELETE },
            { label: 'Changer le statut', value: PERMISSIONS.SINISTRES_STATUT },
        ],
    },
    {
        title: 'SMS',
        module: 'Gestion',
        items: [
            { label: 'Envoyer des SMS', value: PERMISSIONS.SMS_SEND },
        ],
    },
    {
        title: 'Bilans & États',
        module: 'Rapports',
        items: [
            { label: 'Voir les bilans', value: PERMISSIONS.BILANS_READ },
            { label: 'Exporter les bilans', value: PERMISSIONS.BILANS_EXPORT },
            { label: 'Verser au bordereau assureur', value: PERMISSIONS.BILANS_VERSER },
        ],
    },
    {
        title: 'Compagnies',
        module: 'Configuration',
        items: [
            { label: 'Voir les compagnies', value: PERMISSIONS.COMPAGNIES_READ },
            { label: 'Créer une compagnie', value: PERMISSIONS.COMPAGNIES_CREATE },
            { label: 'Modifier une compagnie', value: PERMISSIONS.COMPAGNIES_UPDATE },
            { label: 'Supprimer une compagnie', value: PERMISSIONS.COMPAGNIES_DELETE },
        ],
    },
    {
        title: "Types d'assurance",
        module: 'Configuration',
        items: [
            { label: 'Voir les types', value: PERMISSIONS.TYPES_ASSURANCE_READ },
            { label: 'Créer un type', value: PERMISSIONS.TYPES_ASSURANCE_CREATE },
            { label: 'Modifier un type', value: PERMISSIONS.TYPES_ASSURANCE_UPDATE },
            { label: 'Supprimer un type', value: PERMISSIONS.TYPES_ASSURANCE_DELETE },
        ],
    },
    {
        title: 'Agences',
        module: 'Configuration',
        items: [
            { label: 'Voir les agences', value: PERMISSIONS.AGENCES_READ },
            { label: 'Créer une agence', value: PERMISSIONS.AGENCES_CREATE },
            { label: 'Modifier une agence', value: PERMISSIONS.AGENCES_UPDATE },
            { label: 'Supprimer une agence', value: PERMISSIONS.AGENCES_DELETE },
        ],
    },
    {
        title: 'Paramétrages (référentiels véhicule, marques…)',
        module: 'Configuration',
        items: [
            { label: 'Voir les paramètres', value: PERMISSIONS.PARAMETRAGES_READ },
            { label: 'Modifier les paramètres', value: PERMISSIONS.PARAMETRAGES_UPDATE },
            { label: 'Créer des paramètres', value: PERMISSIONS.PARAMETRAGES_CREATE },
        ],
    },
    {
        title: 'Gestion des accès',
        module: 'Administration',
        items: [
            { label: 'Voir les administrateurs', value: PERMISSIONS.USERS_READ },
            { label: 'Créer un administrateur', value: PERMISSIONS.USERS_CREATE },
            { label: 'Modifier un administrateur', value: PERMISSIONS.USERS_UPDATE },
            { label: 'Supprimer un administrateur', value: PERMISSIONS.USERS_DELETE },
        ],
    },
    {
        title: 'Rôles',
        module: 'Administration',
        items: [
            { label: 'Voir les rôles', value: PERMISSIONS.ROLES_READ },
            { label: 'Créer un rôle', value: PERMISSIONS.ROLES_CREATE },
            { label: 'Modifier un rôle', value: PERMISSIONS.ROLES_UPDATE },
            { label: 'Supprimer un rôle', value: PERMISSIONS.ROLES_DELETE },
        ],
    },
    {
        title: 'Audit',
        module: 'Administration',
        items: [
            { label: "Voir le journal d'audit", value: PERMISSIONS.AUDIT_READ },
        ],
    },
];

// Raccourcis de vérification
export const hasPerm = (user, perm) => {
    if (!user) return false;
    if (['superAdmin', 'directeur'].includes(user.role)) return true;
    return Array.isArray(user.permissions) && user.permissions.includes(perm);
};

export const hasAny = (user, perms = []) => {
    if (!user) return false;
    if (['superAdmin', 'directeur'].includes(user.role)) return true;
    return perms.some((p) => hasPerm(user, p));
};

export const hasAll = (user, perms = []) => {
    if (!user) return false;
    if (['superAdmin', 'directeur'].includes(user.role)) return true;
    return perms.every((p) => hasPerm(user, p));
};

// Presets (optionnel) pour remplir rapidement un profil
export const ROLE_PRESETS = {
    superAdmin: () => Object.values(PERMISSIONS),
    directeur: () => Object.values(PERMISSIONS),
    responsableAgence: () => [
        PERMISSIONS.DASHBOARD_VIEW,
        PERMISSIONS.CLIENTS_READ,
        PERMISSIONS.CLIENTS_CREATE,
        PERMISSIONS.CLIENTS_UPDATE,
        PERMISSIONS.CONTRATS_READ,
        PERMISSIONS.CONTRATS_CREATE,
        PERMISSIONS.CONTRATS_UPDATE,
        PERMISSIONS.CONTRATS_RENOUVELER,
        PERMISSIONS.CONTRATS_ECHELONNER,
        PERMISSIONS.REGLEMENTS_READ,
        PERMISSIONS.REGLEMENTS_CREATE,
        PERMISSIONS.REGLEMENTS_UPDATE,
        PERMISSIONS.IMPAYES_READ,
        PERMISSIONS.IMPAYES_RELANCE,
        PERMISSIONS.SINISTRES_READ,
        PERMISSIONS.SINISTRES_CREATE,
        PERMISSIONS.SINISTRES_UPDATE,
        PERMISSIONS.SINISTRES_STATUT,
        PERMISSIONS.BILANS_READ,
        PERMISSIONS.BILANS_EXPORT,
        PERMISSIONS.COMPAGNIES_READ,
        PERMISSIONS.TYPES_ASSURANCE_READ,
        PERMISSIONS.AGENCES_READ,
    ],
    commercial: () => [
        PERMISSIONS.DASHBOARD_VIEW,
        PERMISSIONS.CLIENTS_READ,
        PERMISSIONS.CLIENTS_CREATE,
        PERMISSIONS.CLIENTS_UPDATE,
        PERMISSIONS.CONTRATS_READ,
        PERMISSIONS.CONTRATS_CREATE,
        PERMISSIONS.REGLEMENTS_READ,
        PERMISSIONS.REGLEMENTS_CREATE,
        PERMISSIONS.IMPAYES_READ,
        PERMISSIONS.SINISTRES_READ,
        PERMISSIONS.SINISTRES_CREATE,
        PERMISSIONS.COMPAGNIES_READ,
        PERMISSIONS.TYPES_ASSURANCE_READ,
    ],
    comptable: () => [
        PERMISSIONS.DASHBOARD_VIEW,
        PERMISSIONS.CLIENTS_READ,
        PERMISSIONS.CONTRATS_READ,
        PERMISSIONS.REGLEMENTS_READ,
        PERMISSIONS.REGLEMENTS_CREATE,
        PERMISSIONS.REGLEMENTS_UPDATE,
        PERMISSIONS.IMPAYES_READ,
        PERMISSIONS.BILANS_READ,
        PERMISSIONS.BILANS_EXPORT,
    ],
    consultation: () => [
        PERMISSIONS.DASHBOARD_VIEW,
        PERMISSIONS.CLIENTS_READ,
        PERMISSIONS.CONTRATS_READ,
        PERMISSIONS.REGLEMENTS_READ,
        PERMISSIONS.IMPAYES_READ,
        PERMISSIONS.SINISTRES_READ,
        PERMISSIONS.BILANS_READ,
    ],
};
